import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import SvgIcon from "@mui/material/SvgIcon";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';

import { useTranslation } from 'react-i18next';

import AirlineSeatFlatIcon from '@mui/icons-material/AirlineSeatFlat';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { KWPS, AirlineSeatFlatIconTop, DriveTrain } from '../helper/Icons';


const ExpandMore = styled((props) => {
	const { expand, ...other } = props;
  	return <IconButton {...other} />;
	})(({ theme, expand }) => ({
  		transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
		    duration: theme.transitions.duration.shortest,
		 }),
}));

export default function ModelCard(props) {
	const [expanded, setExpanded] = React.useState(false);
	const [checked, setChecked] = React.useState(false);
	

	const { t, i18n } = useTranslation("",{lng: props.language});

	const handleChange1 = (event, code, producer) => {
		props.setExtCode(code);
		props.changeConfiguration(event, "internal", code, producer,props.model)
  	};

	const handleChange = (event, code, producer) => {
		try {
			if(event.target.checked === true) {
				props.changeConfiguration(event, "internal", code, producer,props.model)
				props.setExtCode(code);
		    	setChecked(true);
			}
			else {
				props.setExtCode("");
				props.changeConfiguration("");
	    		setChecked(false);
			}
		}
		catch (error) {
				props.setExtCode("");
				props.changeConfiguration("");
	    		setChecked(false);
		}		
  	};

	const doChange = (event, code, producer) => {
		props.changeConfiguration(event, "internal", code, producer, props.model)
		props.setWhichConfiguration(code)
		props.setExtCode(code);
		props.handleNext();

  	};


  	return (
			<Card sx={{ maxWidth: 345 }} className="centerCarCard">
      			<CardHeader avatar={
					          <img style={{height: "30px", bgcolor: "#fff" }} aria-label="recipe" src={"/assets/logos/" + props.model.producerLogo} />					           
					          
					        }
        					title={props.model.label}
							subheader={props.model.slogan}
      			/>
      			<div 
	      			onClick={e => doChange(e, props.model.configCode, props.producer)}
      			>
			      	<CardMedia 	component="img"
			        			height="194"
			        			
			        			image={props.model.image}		        			
			      	/>
				</div>
      			<CardActions disableSpacing>
					<Button variant="contained"
							onClick={e => handleChange1(e, props.model.configCode, props.producer)}
							sx={{float: "right"}}
							>
					  {t("auswählen")}
					</Button>
					
      			</CardActions>
				
      			<CardContent>
			        <Typography variant="body2" color="text.secondary">
						{t("UVP")}<br/>{t("ab")} {Number(props.model.price).toLocaleString("de-DE", {minimumFractionDigits: 2}) + " €"}
			        </Typography>

			        <Typography variant="body2" color="text.secondary" sx={{ paddingTop:"10px", fontWeight: 400 }}>
				        {props.model.discount && props.model.showDiscount == "true" ? (
					        <>
							minus {Number(props.model.discount).toLocaleString("de-DE", {minimumFractionDigits: 2}) } {t("% Nachlass auf das Basisfahrzeug")}</>
				        ):(<></>)
				        }
					</Typography>


			        <br/>
		          		<Typography paragraph sx={{marginBottom: "0px"}}>{t("Motor")}:</Typography>
	          			<Typography paragraph>
			 				<ul class="empty" style={{listStyleType: "none", marginTop: "0px"}}>
								<li><SvgIcon><KWPS/></SvgIcon>{props.model.ps}</li>
								<li><SvgIcon><DriveTrain/></SvgIcon>{props.model.DriveTrain}</li>
								<li><LocalGasStationIcon sx={{fontSize: "1.5em"}}/>{props.model.fuel}</li>
								<li><EngineeringIcon sx={{fontSize: "1.5em"}}/>{props.model.gears}</li>
							</ul>
						</Typography>
		          		<Typography paragraph sx={{marginBottom: "0px"}}>{t("Ausstattung")}:</Typography>
	          			<Typography paragraph>
						<ul class="empty" style={{listStyleType: "none", marginTop: "0px"}}>
							<li><AirlineSeatReclineNormalIcon sx={{fontSize: "1.5em"}}/>{props.model.seatsOptional == "0" ? props.model.seats : props.model.seats + "+" + props.model.seatsOptional} {t("seats")}</li>

{props.model.sleepingplacesTop ? (
										<>
											<li><AirlineSeatFlatIcon sx={{fontSize: "1.5em"}}/>{props.model.sleepingplaces} {t("sleepingPlaces")} {t("unten")}</li>
											<li><SvgIcon sx={{fontSize: "1.8em !important", marginRight: "2px"}}><AirlineSeatFlatIconTop   /></SvgIcon>{props.model.sleepingplacesTop} {t("sleepingPlaces")} {t("Schlafdach")}
{props.model.advice === "" ? (<>&nbsp;(optional)</>): (<></>)}
	
											
											</li>
										</>
										) :(
										<li><AirlineSeatFlatIcon sx={{fontSize: "1.5em"}}/>{props.model.sleepingplaces}  {t("sleepingPlaces")}</li>
										)
									}


							{props.model.size ? ( 
								<li><ViewInArIcon sx={{fontSize: "1.5em"}}/>{props.model.size.outerLength}cm x {props.model.size.outerWidth}cm x {props.model.size.outerHeight}cm </li>
								) :(<></>)
							}
							{props.model.sizeIncludingRoof ? ( 
								<li><ViewInArIcon sx={{fontSize: "1.5em"}}/>{props.model.sizeIncludingRoof.outerLength}cm x {props.model.sizeIncludingRoof.outerWidth}cm x {props.model.sizeIncludingRoof.outerHeight}cm {t("inklSchlafdach")}</li>
								) :(<></>)
							}
						</ul>											        			
						</Typography>
			        
				</CardContent>
    		</Card>
  );
}